import template from './dashboard-actions-block.html';
import controller from './dashboard-actions.controller';

import './dashboard-actions-block.scss';

export default {
	template,
	controller,
	bindings: {
		widgetId: '<',
		isOpen: '=?',
	},
};
